import sortBy from "lodash/sortBy";
import API from "serviceshift-ui/api-client";

export function sortEquipment(equipment = []) {
  return sortBy(equipment, (item) => item.name.toLowerCase());
}

export function sortCustomerEquipment(equipment = []) {
  return sortBy(equipment, (item) => item.id).reverse();
}

export default {
  async fetchCustomerEquipment({ commit }, { link, addressId }) {
    try {
      const res = await API.makeRequest(link, {
        method: "GET",
        params: {
          address_id: addressId
        }
      });
      const equipment = sortCustomerEquipment(res.data);
      commit("replace", {
        state: "customerEquipment",
        data: equipment
      });
    } catch (e) {
      // no-op
    }
  },
  async fetchEquipment(_, { customerId, equipmentId }) {
    const res = await API.makeRequest(
      `/v3/customers/${customerId}/equipment/${equipmentId}`,
      {
        method: "GET"
      }
    );
    return res.data;
  },
  async fetchEquipmentAtLocation(_, { customerId, addressId }) {
    const res = await API.makeRequest(
      `/v3/customers/${customerId}/equipment/at_location?address_id=${addressId}`,
      {
        method: "GET"
      }
    );
    return res.data;
  },
  async convertGenericEquipment({ dispatch }, { link, customer, data }) {
    await API.makeRequest(link, { method: "POST", data });
    return dispatch("fetchCustomerEquipment", customer.links.fetch_equipment);
  },
  async createEquipment(_, { link, data }) {
    const res = await API.makeRequest(link, {
      method: "POST",
      data
    });
    return res.data;
  },
  async updateEquipment({ dispatch }, { customer, link, data }) {
    await API.makeRequest(link, {
      method: "PUT",
      data
    });
    return dispatch("fetchCustomerEquipment", customer.links.fetch_equipment);
  },
  async replaceEquipment({ dispatch }, { link, customer, data }) {
    await API.makeRequest(link, {
      method: "POST",
      data
    });
    return dispatch("fetchCustomerEquipment", customer.links.fetch_equipment);
  },
  async replaceEquipmentComponents({ dispatch }, { link, customer, data }) {
    await API.makeRequest(link, {
      method: "POST",
      data
    });
    return dispatch("fetchCustomerEquipment", customer.links.fetch_equipment);
  },
  async fetchServiceHistoryByEquipmentId(_, link) {
    const response = await API.makeRequest(link);
    return response.data;
  }
};
